import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import ErrorBoundary from "@/components/ErrorBoundary";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import BusinessSetup from "@/pages/BusinessSetup";
import Tradelines from "@/pages/Tradelines";
import Settings from "@/pages/Settings";
import Team from "@/pages/Team";
import PrivateBanking from "@/pages/PrivateBanking";
import LetterTemplates from "@/pages/LetterTemplates";
import SignPortal from "@/pages/SignPortal";
import PaymentResult from "@/pages/PaymentResult";

function Protected({ children, staffOnly }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (staffOnly && user.role === "agent") return <Navigate to="/clients" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App grain">
      <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/sign/:token" element={<SignPortal />} />
            <Route path="/payment/success" element={<PaymentResult />} />
            <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
            <Route path="/" element={<Protected staffOnly><Dashboard /></Protected>} />
            <Route path="/clients" element={<Protected><Clients /></Protected>} />
            <Route path="/clients/:id" element={<Protected><ClientDetail /></Protected>} />
            <Route path="/business" element={<Protected><BusinessSetup /></Protected>} />
            <Route path="/tradelines" element={<Protected><Tradelines /></Protected>} />
            <Route path="/private-banking" element={<Protected staffOnly><PrivateBanking /></Protected>} />
            <Route path="/templates" element={<Protected staffOnly><LetterTemplates /></Protected>} />
            <Route path="/team" element={<Protected staffOnly><Team /></Protected>} />
            <Route path="/settings" element={<Protected staffOnly><Settings /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors theme="dark" />
      </AuthProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
